import React from 'react';
import TableHead from '../../common/tableHead'
import { connect } from 'react-redux';

function FarmSubscriptionsHead({isGroguruAdmin, isEditMode}) {

    let headings = [
        {text: 'UID', className: 'uid-width'},
        {text: 'Site ID Name', className: 'site-name-width'},
        // Show either Subscribed Plan (view mode) or Gold Silver None (edit mode)
        ...(isEditMode
            ? [{text: 'Gold Silver None', className: 'actions-width'}]
            : [{text: 'Subscribed Plan', className: 'subscription-width'}]
        ),
        {text: 'Active', className : 'active-width' }
    ];

    return <TableHead heads={headings} />
}

const mapStateToProps = state => ({
    isGroguruAdmin: state.userDetails.profileDetails.profile.role.name === 'groguru_admin'
})

export default connect(mapStateToProps)(FarmSubscriptionsHead);